import {ProjectNs} from '@shared/types/project.namespace';
import {CommonNs} from "@shared/types/common.namespace";
import {ProductNs} from "@shared/types/product.namespace";

export namespace WorkspaceNs {

    export interface Workspace {
        id: string,
        wsId: string,
        name: string,
        company: string,
        url: string,
        userRole: 'OWNER' | 'ADMIN' | 'MEMBER',
        avatar?: string,
        textAvatar: string,
        isActive?: boolean,
        productType: ProductNs.ProductType,
        dealsId: number,
        productConfig: ProductConfig
    }

    export interface SelectedWorkspaceInfo {
        id: string,
        name: string,
    }

    export interface ProductConfig {
        productKey: ProductNs.ProductType,
        maxProjectCount: number,
    }

    export enum WorkspaceRoleEnum {
        OWNER = 'OWNER',
        ADMIN = 'ADMIN',
        MEMBER = 'MEMBER'
    }

    export interface Member {
        id: number,
        fullName: string,
        avatar: string,
        socialAvatar: string,
        fullNameAvatar: string,
        workspaceRole: string,
        userName: string,
        memberStatus: string,
        lastActivity: string,
        invitedDate: string,
        assignedProject: number,
    }

    /** Account - General Info - Workspace Left/Delete */
    export interface WorkspaceActionRequest {
        workspaceId: string,
        password: string,
    }

    /** Account - General Info - Confirmation to Workspace Left/Delete */
    export interface ConfirmWorkspaceActionRequest {
        confirmationCode: string,
        userId: string,
        workspaceId: string,
    }

    export interface ChangeWorkspaceMemberStatusRequest {
        workspaceId: string,
        memberId: number,
        newStatus: string
    }

    export interface ChangeWorkspaceMemberRoleRequest {
        workspaceId: string,
        memberId: number,
        newRole: string
    }

    export interface RemoveWorkspaceMemberRequest {
        workspaceId: string,
        memberId: number,
        userName: string,
        removeInvitation: boolean
    }

    export interface InviteMember {
        email: string,
        workspaceRole: CommonNs.WorkspaceRoleEnums,
        projectRole: ProjectNs.ProjectRoleEnums,
    }

    export interface InviteMembersRequest {
        workspaceId: string,
        projectId?: string,
        emailAddresses: InviteMember[],
    }

}
